import {RedirectService} from '../services/redirect.service';
import {Directive, HostBinding} from '@angular/core';
import {ExternalRedirectDirective} from './externalRedirect';

@Directive({
  selector: 'a[externalRedirect],area[externalRedirect]'
})
export class ExternalRedirectWithHref extends ExternalRedirectDirective {

  constructor(readonly redirect: RedirectService) {
    super(redirect);
  }

  @HostBinding('href') get href() { return this.url; }
}
